import { ActionContext } from "vuex";
import {
  CustomerContractDetail,
  CustomerContractListItem,
  CustomerLoanDetail,
  CustomerLoanListItem,
} from "@/models/customerPortal.model";
import customerService from "@/services/customerService";

interface State {
  loans: CustomerLoanListItem[];
  contracts: CustomerContractListItem[];
  currentLoan: CustomerLoanDetail | null;
  currentContract: CustomerContractDetail | null;
}

type Ctx = ActionContext<State, any>;

const state: State = {
  loans: [],
  contracts: [],
  currentLoan: null,
  currentContract: null,
};

const mutations = {
  setLoans(currentState: State, payload: CustomerLoanListItem[]) {
    currentState.loans = payload;
  },
  setContracts(currentState: State, payload: CustomerContractListItem[]) {
    currentState.contracts = payload;
  },
  setCurrentLoan(currentState: State, payload: CustomerLoanDetail | null) {
    currentState.currentLoan = payload;
  },
  setCurrentContract(currentState: State, payload: CustomerContractDetail | null) {
    currentState.currentContract = payload;
  },
};

const actions = {
  async loadLoans({ commit, dispatch }: Ctx) {
    try {
      const response = await customerService.listLoans();
      commit("setLoans", response);
      return response;
    } catch (error) {
      await dispatch("notificator/apiError", error, { root: true });
      throw error;
    }
  },

  async fetchLoan({ commit, dispatch }: Ctx, loanId: string) {
    try {
      const response = await customerService.getLoanById(loanId);
      commit("setCurrentLoan", response);
      return response;
    } catch (error) {
      commit("setCurrentLoan", null);
      await dispatch("notificator/apiError", error, { root: true });
      throw error;
    }
  },

  async loadContracts({ commit, dispatch }: Ctx) {
    try {
      const response = await customerService.listContracts();
      commit("setContracts", response);
      return response;
    } catch (error) {
      await dispatch("notificator/apiError", error, { root: true });
      throw error;
    }
  },

  async fetchContract({ commit, dispatch }: Ctx, contractId: string) {
    try {
      const response = await customerService.getContractById(contractId);
      commit("setCurrentContract", response);
      return response;
    } catch (error) {
      commit("setCurrentContract", null);
      await dispatch("notificator/apiError", error, { root: true });
      throw error;
    }
  },
};

const getters = {
  loans: (currentState: State) => currentState.loans,
  contracts: (currentState: State) => currentState.contracts,
  currentLoan: (currentState: State) => currentState.currentLoan,
  currentContract: (currentState: State) => currentState.currentContract,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
